import { ApostleLite } from '@apeiron/apostle'
import { usePath } from '@apeiron/ui'
import MarketplaceApostleCard from '@src/components/apostles/card/MarketplaceApostleCard'
import FetchedApostleListPublic from '@src/components/apostles/list/FetchedApostleListPublic'
import EmporiumSecNavBar from '@src/components/navigationBar/secondary/EmporiumSecNavBar'
import ApostleThirdNavBar from '@src/components/navigationBar/third/ApostleThirdNavBar'
import { WhiteList } from '@src/constants/page'
import { ROUTE } from '@src/constants/route'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import { NextPage } from 'next'
import queryString from 'query-string'
import { useCallback, useEffect } from 'react'

const ApostleActivityPage: NextPage<Props> = () => {
  const { setupBar } = useSecondaryNavBarContext()

  const { replacePath } = usePath(WhiteList)

  useEffect(() => {
    setupBar(<EmporiumSecNavBar index={1} />)

    return () => setupBar(null)
  }, [setupBar])

  const handleUrl = useCallback((apostle: ApostleLite) => {
    const url = queryString.stringifyUrl({
      url: ROUTE.MARKETPLACE_APOSTLE_DETAIL,
      query: {
        apostleId: apostle.id
      }
    })

    return replacePath(url)
  }, [])

  const handleRenderCard = useCallback((apostle: ApostleLite) => {
    return (
      <MarketplaceApostleCard
        apostle={apostle}
        key={apostle.id}
        enableLink
        url={handleUrl(apostle)}
      />
    )
  }, [])

  return (
    <FetchedApostleListPublic
      thirdNavBar={<ApostleThirdNavBar index={0} />}
      renderCard={handleRenderCard}
      withTracking
    />
  )
}

type Props = {}

export default ApostleActivityPage
